export default __webpack_public_path__ + "static/BZ_COBERTURADC_EP_R00-1_Pgina_31-8d5c1b19d9c33405dd4a16537b5e8fcf.jpg";